var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-loading-spinner position-relative" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
        staticClass: "loading-progress",
        class: _vm.loadingProgressClasses,
      },
      [
        _c("ob1-progress-indicators", {
          staticClass: "progress-indicator",
          attrs: { type: "undetermined", size: 50 },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }